<main>
    <app-toolbar></app-toolbar>
    <div class="content">
      <app-sidebar></app-sidebar>
      <div class="main-content" [ngClass]="{'collapsed-sidebar-content': sidebarService.isSidebarToggled$ | async}"> 
        <router-outlet>
        </router-outlet></div>
    </div>
  </main>